import React from "react"

import { ProductPosition } from "shared/types/ProductPosition"

import { ProductPositionActionsOverlayView } from "widgets/product-position/product-position-actions-overlay/ProductPositionActionsOverlayView"

import { useFavoriteActionsOverlayModel } from "./hooks/useFavoriteActionsOverlayModel"

export interface FavoriteActionsOverlayPayload {
  productPosition: ProductPosition
}

export interface FavoriteActionsOverlayConnectorProps {
  payload: FavoriteActionsOverlayPayload
}

export const FavoriteActionsOverlayConnector = React.memo(
  (props: FavoriteActionsOverlayConnectorProps) => (
    <ProductPositionActionsOverlayView
      {...useFavoriteActionsOverlayModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    FAVORITE_ACTIONS_OVERLAY: FavoriteActionsOverlayPayload
  }
}
